"use strict";
'use client';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSingleInputDateTimeRangeField = void 0;
var React = _interopRequireWildcard(require("react"));
var _internals = require("@mui/x-date-pickers/internals");
var _hooks = require("@mui/x-date-pickers/hooks");
var _valueManagers = require("../internals/utils/valueManagers");
var _validation = require("../validation");
const useSingleInputDateTimeRangeField = inProps => {
  const props = (0, _internals.useDefaultizedDateTimeField)(inProps);
  const {
    forwardedProps,
    internalProps
  } = (0, _hooks.useSplitFieldProps)(props, 'date-time');
  const fieldValueManager = React.useMemo(() => (0, _valueManagers.getRangeFieldValueManager)({
    dateSeparator: internalProps.dateSeparator
  }), [internalProps.dateSeparator]);
  return (0, _internals.useField)({
    forwardedProps,
    internalProps,
    valueManager: _valueManagers.rangeValueManager,
    fieldValueManager,
    validator: _validation.validateDateTimeRange,
    valueType: 'date-time'
  });
};
exports.useSingleInputDateTimeRangeField = useSingleInputDateTimeRangeField;